export default __webpack_public_path__ + "static/media/Alfred_Oscar_Coffin.7850b342.jpg";